module.exports = __webpack_public_path__ + "static/media/editieren.366235a4.svg";